export default {
  name: 'marking--statusMapUpload',
  apiService: 'shoes',
  apiPath: '/admin/status_map/upload',
  urlParamName: 'marking--statusMapUpload',
};